let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("akLPz")).then(() => parcelRequire('8N9fs'));